module.exports = __webpack_public_path__ + "img/sprite.e732eeba.svg";